import React, { ForwardedRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedElement,
  updateSelectedInteraction,
} from "./../../../app/slices/TrainingSlice";
import { arrayMove } from "@dnd-kit/sortable";
import PiDragContainer, {
  ContainerStyle,
} from "../../../components/PiDragContainer";

import { IConversation } from "../../../models/interactions/Conversation";
import { IMessageBubble } from "../../../models/interactions/MessageBubble";
import { IEmotionBubble } from "../../../models/interactions/EmotionBubble";
import { GetMessageStrategy } from "./MessageBubbleStrategy";
import { InteractionType } from "../../../models/interactions/Interaction";
import { ConversationMessageBubble } from "./ConversationMessageBubble";
import { ConversationEmotionBubble } from "./ConversationEmotionBubble";

interface ConversationPreviewMessageViewProps {
  onDetailsSelect: (message: IMessageBubble | IEmotionBubble) => void;
}

const ConversationPreviewMessageView = forwardRef<
  HTMLDivElement,
  ConversationPreviewMessageViewProps
>(({ onDetailsSelect }, ref: ForwardedRef<HTMLDivElement>) => {
  const conversation = useSelector(selectSelectedElement) as IConversation;
  const dispatch = useDispatch();

  const msgs = conversation?.messages.map((msg) => {
    console.log("msg type:" + msg.type);
    switch (msg.type) {
      case InteractionType.MessageBubble:
        return (
          <ConversationMessageBubble
            key={msg.id}
            message={msg}
            onSettingsClicked={() => onDetailsSelect(msg)}
          />
        );
      case InteractionType.EmotionBubble:
        return (
          <ConversationEmotionBubble
            message={msg}
            onSettingsClicked={() => onDetailsSelect(msg)}
            key={msg.id}
          />
        );
      default:
        return (
          <ConversationMessageBubble
            key={msg.id}
            message={msg}
            onSettingsClicked={() => onDetailsSelect(msg)}
          />
        );
    }
    //return GetMessageStrategy(msg).getPreview(msg, () => onDetailsSelect(msg));
  });

  function onHandleDragEnd(prevIndex: number, newIndex: number) {
    var originalMessages = [...conversation.messages];

    const newConversation = { ...conversation };
    newConversation.messages = arrayMove(originalMessages, prevIndex, newIndex);

    dispatch(updateSelectedInteraction(newConversation));
  }

  return (
    <div
      className="flex flex-col flex-1 gap-[10px] p-4 pl-0 pr-0 border-b-2 border-interaction-primary-washed clip pit-scrollbar overflow-y-auto"
      ref={ref}
    >
      <PiDragContainer
        onHandleDragEnd={onHandleDragEnd}
        containerElements={msgs}
        uniqueIds={conversation.messages.map((m) => m.id)}
        containerStyle={ContainerStyle.Default}
      />
    </div>
  );
});

export default ConversationPreviewMessageView;
